'use strict';

module.exports = {
	arrowLeft: require('./arrowLeft'),
	arrowRight: require('./arrowRight'),
	close: require('./close')
};


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/github.com+petflow+react-images@b493075cbbc68a1a48b51bede9ea2be2846996cf_75majzr67pr6dysc3w5lngjsty/~/react-images/lib/icons/index.js
// module id = 351
// module chunks = 0